import { useTranslation } from "react-i18next";
// import { useLocation } from "react-router-dom";
import { useBookInfContext } from "components/context/bookInfContext";
import "./step2.scss";
import { useActionState } from "react";
import { useAuthContext } from "components/context/authContext";

type IInRow = {
  isUseInf: boolean;
  isBorderbt?: boolean;
};

const InfRow = ({ isUseInf, isBorderbt }: IInRow) => {
  const { t } = useTranslation();
  // const { state } = useLocation();
  const { bookInf } = useBookInfContext();
  const { userInf } = useAuthContext();

  return (
    <ul
      className={
        "between-center py-6" +
        " " +
        (isBorderbt ? "border-bt-0" : "border-bt-dashed")
      }
    >
      <li className="between-center gap-2">
        <p className="xxs">객실1</p>
        <h3 className="text-blue-300">{bookInf?.rmTypNm ?? "-"}</h3>
      </li>
      {isUseInf && (
        <li>
          <h5 className="font-font-B">
            {t("txt_adlt_bk")}&nbsp;{bookInf?.adltCnt}&nbsp;{"/"}&nbsp;
            {t("txt_chld_bk")}&nbsp;
            {bookInf?.childCnt}
          </h5>
        </li>
      )}
    </ul>
  );
};

export default function BookStep2() {
  const { t } = useTranslation();
  const infList = [1];

  const opList: any[] = [];

  return (
    <div className="op-list">
      <h3 className="sub">{t("bck_ttl_rm_bk")}</h3>
      {infList.map((inf, index) => {
        return <InfRow key={index} isUseInf />;
      })}
      <div className="mt-10">
        <h3 className="sub "> {t("txt_add_op_bk")}</h3>
        {infList.map((inf, index) => {
          return (
            <InfRow
              key={index}
              isUseInf={false}
              isBorderbt={index + 1 === infList.length}
            />
          );
        })}
        <table className="w-full mt-[-13px] table-fixed">
          <thead className="h-12  bg-blue-300-15 ">
            <tr className="h-12">
              <th>{t("th_dt_bk")}</th>
              <th>{t("th_itm_bk")}</th>
              <th>{t("th_unt_pr_bk")}</th>
              <th>{t("th_qtt_bk")}</th>
            </tr>
          </thead>
          <tbody className="h-24 w-full bg-white text-center">
            {opList.length === 0 && (
              <tr className="h-24 w-full table-fixed">
                <td colSpan={4}>
                  <h6>{t("txt_add_op_nan_bk")} </h6>
                </td>
              </tr>
            )}
            {opList &&
              opList.map((op) => {
                return (
                  <tr className="table-fixed w-full">
                    <td></td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
